import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    // scroll au top après chaque navigation
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location]); // s'exécute à chaque changement de route

  return null;
}
